import { useDispatch } from 'react-redux'
import { updateAdditionalSalesConfig } from '../../SubscriptionForm/SubscriptionFormSlice'

const useAdditionalSaleScript = () => {
  const dispatch = useDispatch()
  const scrollToAdditionalSaleTab = saleName => {
    dispatch(
      updateAdditionalSalesConfig({
        scrollToAdditionalSaleTab: true,
        additionalSaleTabNameToScroll: saleName,
      }),
    )
  }

  return {
    scrollToAdditionalSaleTab,
  }
}
export default useAdditionalSaleScript
